"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuPopover", {
    enumerable: true,
    get: function() {
        return MenuPopover;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuPopover = require("./useMenuPopover");
const _useMenuPopoverStylesstyles = require("./useMenuPopoverStyles.styles");
const _renderMenuPopover = require("./renderMenuPopover");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuPopover = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuPopover.useMenuPopover_unstable)(props, ref);
    (0, _useMenuPopoverStylesstyles.useMenuPopoverStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuPopoverStyles_unstable')(state);
    return (0, _renderMenuPopover.renderMenuPopover_unstable)(state);
});
MenuPopover.displayName = 'MenuPopover';
